import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { showSuccessToast, showAlertToast } from '@medflex/components/stories/Toast';
import { TRACKING_ACTIONS, trackEvent } from '@medflex/utils/Tracking';

const usePhysicianInvitations = () => {
  const { pending, redeemed } = useSelector(state => state.physicianInvitation);
  const dispatch = useDispatch();
  const { t } = useTranslation('physician');
  const history = useHistory();

  const create = async payload => {
    await dispatch.physicianInvitation.create(payload);
  };

  const redeem = async ({ id }) => {
    try {
      await dispatch.physicianInvitation.redeem({
        id,
        inviterName: null,
      });
      trackEvent({
        zone: 'Arzt2Arzt_Einladung',
        action: TRACKING_ACTIONS.ACCEPT,
        actionText: 'Accept invitation by permanentId',
      });
    } catch (e) {
      showAlertToast(
        t('physician_invite_token.errors.exception.title'),
        t('physician_invite_token.errors.exception.text'),
        { toastId: 'invitationAcceptFailed' },
      );
      throw new Error();
    }
  };
  useEffect(() => {
    if (redeemed.id) {
      if (redeemed.inviterName) {
        showSuccessToast(
          t('physician_invite_token.success.title', { name: redeemed.inviterName }),
          <span>
            <button
              type="button"
              className="text-blue-500"
              onClick={() => history.push(`/chat/${redeemed.id}`)}
            >
              {t('physician_invite_token.success.text')}
            </button>
          </span>,
          { toastId: 'invitationAcceptSucceeded' },
        );
      } else {
        showSuccessToast(t('physician_invite_token.success_permanent'), null, {
          toastId: 'permanentInvitationSuccess',
        });
      }
    }
  }, [redeemed.id, redeemed.inviterName]);

  useEffect(() => {
    if (redeemed.notFound) {
      showAlertToast(
        t('physician_invite_token.errors.not_found.title'),
        t('physician_invite_token.errors.not_found.text'),
        { toastId: 'inviteTokenNotFound' },
      );
    }
  }, [redeemed.notFound]);

  useEffect(() => {
    if (redeemed.isSelf) {
      showAlertToast(
        t('physician_invite_token.errors.is_self.title'),
        t('physician_invite_token.errors.is_self.text'),
        { toastId: 'inviteTokenIsSelf' },
      );
    }
  }, [redeemed.isSelf]);

  return {
    create,
    pending,
    redeem,
    cleanupPending: dispatch.physicianInvitation.cleanupPending,
    redeemed,
  };
};

export default usePhysicianInvitations;
